import Alert from "../components/alert";
import Toast from "../components/toast";
import IntercomProvider from "../components/IntercomProvider";

function Wrapper({ children }) {
  return (
    <IntercomProvider>
      <div>
        {children}

        <Alert />

        <Toast />
      </div>
    </IntercomProvider>
  );
}

export default Wrapper;
